import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import AISparkleIcon from './AISparkleIcon'

const AILabelContainer = styled(Group)`
  align-items: center;
  gap: ${rem(4)};
`

/** Text can use CSS background-clip: text to achieve gradient fills */
const AILabelText = styled(BodyText)`
  background: ${props => props.theme.palette.product.ai.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`

interface Props {
  label: string
  variant?: 'medium' | 'small' | 'large'
  weight?: 'normal' | 'bold'
}

function AISearchLabel(props: Props) {
  const { label, variant = 'medium', weight = 'bold' } = props

  return (
    <AILabelContainer direction="horizontal" gap={4}>
      <AISparkleIcon />
      <AILabelText variant={variant} weight={weight}>
        {label}
      </AILabelText>
    </AILabelContainer>
  )
}

export default AISearchLabel
